import { experience } from '@/data/experience';
import { formatDateRange } from '@/utils/cn';
import { Container, SectionHeading } from '@/components/common/SectionHeading';
import styles from './Experience.module.css';

export function Experience() {
  return (
    <section id="experience" className="section" aria-labelledby="experience-heading">
      <Container>
        <SectionHeading
          id="experience-heading"
          eyebrow="Experience"
          title="Professional experience"
          description="Roles spanning backend systems, web applications, and mobile products."
        />
        <ol className={styles.timeline}>
          {experience.map((item) => (
            <li key={item.id} className={styles.item}>
              <div className={styles.marker} aria-hidden="true" />
              <article className={styles.card}>
                <header className={styles.header}>
                  <div>
                    <h3 className={styles.company}>{item.company}</h3>
                    <p className={styles.role}>{item.role}</p>
                    {item.location ? <p className={styles.location}>{item.location}</p> : null}
                  </div>
                  <p className={styles.dates}>{formatDateRange(item.startDate, item.endDate)}</p>
                </header>
                {item.summary ? <p className={styles.summary}>{item.summary}</p> : null}
                <ul className={styles.responsibilities}>
                  {item.responsibilities.map((responsibility) => (
                    <li key={responsibility}>{responsibility}</li>
                  ))}
                </ul>
                <ul className={styles.tech} aria-label={`Technologies used at ${item.company}`}>
                  {item.technologies.map((tech) => (
                    <li key={tech}>{tech}</li>
                  ))}
                </ul>
              </article>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}
